import { Gender } from "@./cat-calculations";
import { formatCatNames } from "apps/website/utils/misc/strings";

interface IPronouns {
  pronoun: "he" | "she" | "they";
  possessivePronoun: "his" | "her" | "their";
  objectPronoun: "him" | "her" | "them";
  contractedPronoun: "he's" | "she's" | "they're";
}

const PRONOUNS: Record<Gender, IPronouns> = {
  BOY: { pronoun: "he", possessivePronoun: "his", objectPronoun: "him", contractedPronoun: "he's" },
  GIRL: { pronoun: "she", possessivePronoun: "her", objectPronoun: "her", contractedPronoun: "she's" },
  UNKNOWN: { pronoun: "they", possessivePronoun: "their", objectPronoun: "them", contractedPronoun: "they're" },
};

export const getInterpolationVariables = ({ name, gender, names }:
{ name?: string, gender?: Gender, names?: string[] }) => {
  const pronouns = PRONOUNS[gender ?? "UNKNOWN"];

  return {
    pronoun: pronouns.pronoun,
    possessivePronoun: pronouns.possessivePronoun,
    objectPronoun: pronouns.objectPronoun,
    contractedPronoun: pronouns.contractedPronoun,
    catName: name ?? "",
    catNames: formatCatNames(names ?? []) ?? "",
  };
};
